import React, { useEffect, useState } from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
type Props = {
  className?: string;
  color?: Colors;
  iconName: IconName;
  onClick?: () => void;
  onClose?: () => void;
  subtitle?: string | null | undefined;
  text?: string;
  title: string;
  url?: string;
};
export const ToasterImmersive = ({
  color = COLORS.SIENNA,
  iconName,
  onClick,
  onClose,
  subtitle,
  text,
  title,
  url,
}: Props) => {
  const [viewed, setViewed] = useState(false);
  useEffect(() => {
    if (viewed) {
      onClose && onClose();
    }
  }, [viewed]);
  const TagName = url ? DynamicLink : 'div';
  const tagProps = url ? { url, onClick } : { onClick };
  return (
    <div className="relative isolate flex gap-10 py-10 pe-20">
      <Icon className={`shrink-0 text-${color}`} name={iconName} width="1.25rem" />
      <TagName {...tagProps} className="font-sans">
        {title && <h3 className={`text-16 text-${color} font-bold`}>{title}</h3>}
        {!!subtitle && <p className="m-0 font-brand text-24 leading-tight">{subtitle}</p>}
        {text && <Text text={text} theme="text-sans-n1" />}
      </TagName>
      <button
        className="absolute end-0 top-0 leading-0"
        onClick={(e) => {
          e.stopPropagation();
          onClose && onClose();
          setViewed(true);
        }}
        type="button"
      >
        <Icon name={ICONS.CROSS} width="0.75rem" />
      </button>
    </div>
  );
};
